import React, { useContext, useReducer } from 'react'

const initialState = {
  step: 1,
  checkPYME: false,
}
const reducer = (state, action) => {
  switch (action.type) {
    case 'INIT_STEP':
      return { ...state, step: 1 }
    case 'NEXT_STEP':
      if (state.step === 6) {
        return
      } else {
        return { ...state, step: state.step + 1 }
      }
    case 'PREV_STEP':
      if (state.step === 1) {
        return
      } else {
        return { ...state, step: state.step - 1 }
      }
    case 'SET_STATE':
      return { ...state, step: action.payload }
    case 'SET_CHECKPYME':
      return { ...state, checkPYME: action.payload }
    default:
      return state
  }
}

const EligibilityContext = React.createContext()

export const EligibilityContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  React.useEffect(() => {
    dispatch('INIT_STEP')
  }, [])
  return (
    <EligibilityContext.Provider value={[state, dispatch]}>
      {children}
    </EligibilityContext.Provider>
  )
}

export const useEligibility = () => {
  const context = useContext(EligibilityContext)
  if (context === undefined) {
    throw new Error('useEligibility can only be used inside FormProvider')
  }
  return context
}
